const DOMAIN = 'cobranded.services.userSettings.privateArea.cbGeneric.cbError.';

const BUTTON = `${DOMAIN}tryAgainButton`,
  ERROR_DESCRIPTION = `${DOMAIN}description`,
  ERROR_TITLE = `${DOMAIN}title`;

export { BUTTON, ERROR_DESCRIPTION, ERROR_TITLE };
